import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../layout/Footer';

/**
 * Wrapper component for legal document pages
 * Provides consistent styling and layout for Terms, Privacy, and PAIA pages
 */
export default function LegalDocument({ children, title }) {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-dark-bg">
      {/* Header */}
      <header className="border-b border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg sticky top-0 z-10">
        <div className="mx-auto max-w-4xl px-6 py-4">
          <div className="flex items-center justify-between">
            <Link
              to="/"
              className="text-2xl font-black tracking-tight text-gray-900 dark:text-white font-rajdhani"
            >
              SureDox
            </Link>

            <Link
              to="/"
              className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <article className="mx-auto max-w-4xl px-6 py-12">
          <div
            className="legal-content prose prose-gray dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        </article>
      </main>

      {/* Footer */}
      <Footer variant="default" />
    </div>
  );
}
